import { render, staticRenderFns } from "./CompanyArgument.vue?vue&type=template&id=517cf30e&"
import script from "./CompanyArgument.vue?vue&type=script&lang=js&"
export * from "./CompanyArgument.vue?vue&type=script&lang=js&"
import style0 from "./CompanyArgument.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports